{
  "data": {
    "statementType": "not-listed",
    "fullName": {
      "first": "John",
      "last": "Veteran"
    },
    "emailAddress": "testing@gmail.com",
    "dateOfBirth": "1980-01-01",
    "idNumber": {
      "ssn": "321540987"
    },
    "mailingAddress": {
      "country": "USA",
      "street": "123 Any St",
      "city": "Anytown",
      "state": "CA",
      "postalCode": "12345"
    },
    "phone": "1234567890",
    "statement": "John stood at the towering gates of bureaucracy, a maze of forms and lines that seemed endless. Clutched in his hand was the VA Form 21-4138, a cryptic relic said to grant access to essential benefits. As he stepped forward, he encountered gatekeepers—the clerks—each with riddles to solve and documents to verify. Armed with a pen and a folder filled with proof, he navigated the maze, dodging a storm of paper, crossing the chasm of deadlines, and fighting the dragon of waiting times. In the end, he emerged triumphant, his form stamped with approval, the quest for benefits achieved. The adventure, though arduous, had its reward."
  }
}
